import AnswerButton from "./AnswerButton"
import Countdown from "react-countdown"
import { Component } from "react"

class Question extends Component {
  render() {
    return (
      <section className="jumbotron text-center">
        <article className="text-center">
          <span className="badge badge-pill badge-warning">{`Question: ${
            this.props.game.count + 1
          }`}</span>
        </article>
        <h3
          className="question py-2 px-5"
          dangerouslySetInnerHTML={{
            __html: this.props.game.questions[this.props.game.count].question,
          }}
        ></h3>
        <Countdown
          date={Date.now() + 20000}
          renderer={this.renderer}
          onComplete={this.timeOut}
          intervalDelay={0}
          precision={3}
          key={Date.now()}
        >
          <span>Time's up</span>
        </Countdown>

        <div className="container">
          <div className="row">
            {this.props.game.questions[this.props.game.count].allAnswers.map(
              (data, id) => (
                <AnswerButton
                  key={data.answer}
                  text={data.answer}
                  correct={data.correct}
                  answered={this.props.user.answered}
                  checkAnswer={this.checkAnswer}
                  id={id}
                ></AnswerButton>
              )
            )}
          </div>
        </div>
      </section>
    )
  }

  // Function to check answer and move to next one
  checkAnswer = (correct) => {
    // Ignore press if already answered
    if (this.props.user.answered) return

    this.props.handleStateChange({
      user: {
        ...this.props.user,
        answered: true,
      },
    })
    setTimeout(() => {
      if (correct) {
        this.props.handleStateChange({
          user: {
            ...this.props.user,
            score: this.props.user.score + 1,
          },
        })
      }
      this.props.handleStateChange({
        user: {
          ...this.props.user,
          answered: false,
        },
        game: {
          ...this.props.game,
          count: this.props.game.count + 1,
        },
      })
      if (this.props.game.count === this.props.game.numQuestions - 1)
        this.props.handleGameEnd()
    }, 2000)
  }

  // Function to handle the rendering of the timer progress bar
  renderer = ({ seconds, milliseconds }) => {
    return (
      <div
        className={`progress mb-5 ${
          this.props.user.answered ? "invisible" : ""
        }`}
      >
        <div
          className={`progress-bar ${seconds < 5 ? "bg-danger" : "bg-success"}`}
          style={{
            width: `${(((seconds - 2) * 1000 + milliseconds) / 20000) * 100}%`,
          }}
          role="progressbar"
          aria-valuenow={seconds}
          aria-valuemin="0"
          aria-valuemax="20"
        ></div>
      </div>
    )
  }

  // Function to skip to the next question when time expires
  timeOut = () => {
    this.props.handleStateChange({
      game: {
        ...this.props.game,
        count: this.props.game.count + 1,
      },
    })
  }
}

export default Question
